import { UnitDimension } from '@/common/models';

export default class CreativeUnitDimensions {
  private creativeID: number;

  private unitDimensions: UnitDimension;

  constructor(creativeID: number, unitDimensions: UnitDimension) {
    this.creativeID = creativeID;
    this.unitDimensions = unitDimensions;
  }
}
